<script>
export default {
   name: 'Cloud',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="43" height="48" fill="none" viewBox="0 0 43 48">
      <path
         fill="#acb7e8"
         d="M42.013 12.19a.727.727 0 0 0-.754-.7c-2.81.125-4.365-3.251-2.465-5.35a.74.74 0 0 0-.044-1.033l-2.623-2.433a.717.717 0 0 0-1.022.045c-1.9 2.099-5.359.825-5.481-2.02a.726.726 0 0 0-.754-.698l-3.555.157a.73.73 0 0 0-.69.763c.122 2.843-3.214 4.418-5.288 2.494a.716.716 0 0 0-.917-.049c.205.648.318 1.338.318 2.055v.553h.26c.417 0 .756.342.756.766v1.796a.76.76 0 0 1-.756.765h-.883v1.49c0 3.387-3.205 6.133-6.552 6.133 4.338 0 5.79 2.326 7.6 6.005-4.727 3.828-.667 2.233 3.152 2.233 1.514 0 3.423 1.583 3.5 3.385a.727.727 0 0 0 .754.7l3.556-.158a.73.73 0 0 0 .69-.762c-.122-2.844 3.214-4.418 5.288-2.495a.717.717 0 0 0 1.02-.045l2.405-2.655a.74.74 0 0 0-.044-1.033c-2.074-1.923-.815-5.424 1.995-5.548a.73.73 0 0 0 .69-.763z"
      />
      <path
         fill="#fff"
         d="M27.547 22.446c4.32 0 7.821-3.35 7.821-7.482s-3.502-7.482-7.821-7.482c-4.32 0-7.822 3.35-7.822 7.482s3.502 7.482 7.822 7.482"
      />
      <path
         fill="#efb534"
         d="M24.173 17.198H6.054a.987.987 0 0 1-.987-.988v-2.315c0-.545.442-.988.987-.988h18.119c.545 0 .987.442.987.988v2.315a.987.987 0 0 1-.987.988M16.956 9.138H13.27a1.37 1.37 0 0 1-1.354-1.153l-.669-4.138a1.156 1.156 0 0 1 1.142-1.341h5.448c.712 0 1.256.637 1.142 1.34l-.668 4.139a1.37 1.37 0 0 1-1.355 1.153"
      />
      <path
         fill="#ffcec0"
         d="M15.114 27.025a7.91 7.91 0 0 1-7.908-7.908v-1.92H23.02v1.92a7.91 7.91 0 0 1-7.907 7.908"
      />
      <path
         fill="#0778cd"
         d="M15.114 27.026C7.142 27.026 0 32.988 0 47.952h29.547v-5.813c0-8.47-6.462-15.113-14.433-15.113"
      />
      <path
         fill="#f6d530"
         d="M23.834 12.905v-.713a8.72 8.72 0 0 0-4.935-7.852l-.589 3.643a1.37 1.37 0 0 1-1.354 1.154H13.27a1.37 1.37 0 0 1-1.355-1.154l-.588-3.643a8.72 8.72 0 0 0-4.935 7.852v.713zM15.114 27.026c-2.921 0-5.637.87-7.908 2.361v18.565h15.92V29.534c-3.06-1.987-5.093-2.508-8.012-2.508"
      />
      <path fill="#0778cd" d="m15.114 34.86 4.709-7.044a14.4 14.4 0 0 0-9.419 0z" />
   </svg>
</template>

<style scoped lang="scss"></style>
